/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type VerifyGcpIamCredentialSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type VerifyGcpIamCredentialRequest = {
  /**
   * The ID of the credential to verify.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type VerifyGcpIamCredentialSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const VerifyGcpIamCredentialSecurity$outboundSchema: z.ZodMiniType<
  VerifyGcpIamCredentialSecurity$Outbound,
  VerifyGcpIamCredentialSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function verifyGcpIamCredentialSecurityToJSON(
  verifyGcpIamCredentialSecurity: VerifyGcpIamCredentialSecurity,
): string {
  return JSON.stringify(
    VerifyGcpIamCredentialSecurity$outboundSchema.parse(
      verifyGcpIamCredentialSecurity,
    ),
  );
}

/** @internal */
export type VerifyGcpIamCredentialRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const VerifyGcpIamCredentialRequest$outboundSchema: z.ZodMiniType<
  VerifyGcpIamCredentialRequest$Outbound,
  VerifyGcpIamCredentialRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function verifyGcpIamCredentialRequestToJSON(
  verifyGcpIamCredentialRequest: VerifyGcpIamCredentialRequest,
): string {
  return JSON.stringify(
    VerifyGcpIamCredentialRequest$outboundSchema.parse(
      verifyGcpIamCredentialRequest,
    ),
  );
}
